import { render, staticRenderFns } from "./UpdateDialog.vue?vue&type=template&id=2e3bf520&scoped=true"
import script from "./UpdateDialog.vue?vue&type=script&lang=ts"
export * from "./UpdateDialog.vue?vue&type=script&lang=ts"
import style0 from "./UpdateDialog.vue?vue&type=style&index=0&id=2e3bf520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3bf520",
  null
  
)

export default component.exports